export default __webpack_public_path__ + "static/media/gradoil-logo-horizontal.7dd120da.png";